import img from "../media/undraw_interview_yz52 (1).svg"
import Footer from "../components/footer";
import "../css/screening.css"
import logo1 from "../media/whiteFav.png";
import { Icon } from "@iconify/react";
import Navbar from "../components/nav";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import useStore from "../store/zustandstore";
import { db } from "../firebase/firebase";
import { useEffect } from "react";
import usefbStore from "../store/firebasestore";
import { Helmet } from "react-helmet";
import { doc,updateDoc,getDocs,collection } from "firebase/firestore";

function About(){


    const navigate = useNavigate()
    const userID = usefbStore((s)=>s.userID)
    const fonMenuDrawer = useStore((s)=>s.fonMenuDrawer)
    const closeFonMenu = useStore((s)=> s.closeFonMenu)

    const setScreenCount =usefbStore((s)=>s.setScreenCount)
    const screenCount = usefbStore((s)=>s.screenCount)
    const hideScreenLoader= useStore((s)=>s.hideScreenLoader)
      const cnclFon = () =>{
    closeFonMenu();
  }

   const toAuth=()=>{

      navigate("/auth")
    }
     
    useEffect(()=>{
     hideScreenLoader()      
    },[userID])
 
      const toTest = async () =>{
        if(!userID){
                        navigate("/auth")
                        return;
        }
        if(userID){
          if(screenCount == null) return ;
          if(screenCount < 3){
            // fetch all questions
            const snap = await getDocs(collection(db, "Screening"));
            const allQuizIds = snap.docs.map(d => d.id);
            if (allQuizIds.length < 15) {
              throw new Error("Not enough quizzes");
            }
            // shuffle
            const shuffled = allQuizIds.sort(() => 0.5 - Math.random());
            const selected = shuffled.slice(0, 15);
            await updateDoc(doc(db, "Users", userID), {
              quizIds: selected,
              screeningActive: true,
              quizCompleted:false
            }).then(()=>{
                navigate(`/screening/${userID}`)
            })
          }else if(screenCount >= 3){
          Swal.fire(
            "Screening Limit Reached",
            "You've reached the maximum number of attempts. Please contact our support team to request a review or reset.",
            "info"
          );                
          }
 

        }
 

    }
   return (

    <section className="preScreen">
       <Helmet>
            <title>About Us</title>
<meta name="description" content="Solara makes remote work accessible. We connect freelancers with legitimate tasks in a secure, transparent platform. Learn our mission, how we work, and our commitment to freelancers." />
        </Helmet>
            <div className={`fonMenu ${fonMenuDrawer ? "fonMenuActive" : ""}`} >
        <img src={logo1} alt="" />
        <div className="sideMenuPlacer">
          <div className="fonMenuX" onClick={cnclFon}>
                
                <Icon className="faIcon" icon="solar:alt-arrow-right-linear" />
          </div>
          <div className="fonMenuLinks">

             <a href="/jobs">Job Opportunities</a>
             <a href="/dashboard">AI Tasks</a>
             <a href="/referral-program">Referral Program</a>
             <a href="/about">About Us</a>
            <button onClick={()=>toAuth()}>Get Started</button>
          </div>
          
        </div>
      </div>
        <div className="navContWhite navContWhiteLg">
                    <Navbar />
        </div>
        <div className="preScrenCont">
       <div className="preScreenImg">
             <h2>About Us</h2>
        </div>
        <div className="preScreenCont">
            <h3>Welcome to Solara.</h3>
<p>
Congratulations on joining Solara, a modern digital platform designed to connect freelancers with accessible remote work
opportunities.
</p>

<p>
At Solara, our mission is simple: to make online work more accessible, structured, and reliable for freelancers
around the world.
</p>

<p>
We partner with a network of external agencies and organizations to source a wide range of remote tasks and projects.
These opportunities are then made available directly on our platform, allowing freelancers to access and complete work in
a streamlined and user-friendly environment.</p>
       <h3>How Solara Works</h3>

<p>Solara operates as an independent platform that bridges the gap between work providers and freelancers:</p>
       <ul>
        <li>We <b> source and manage tasks</b> from various partner agencies</li>
        <li>We <b> present these opportunities directly to freelancers </b> on our platform</li>
        <li>Freelancers complete tasks <b> within the Solara system </b></li>
       </ul>
       <p>This structure ensures a smooth, consistent experience without requiring direct interaction between freelancers and
third-party agencies.</p>
           
           <h3><span></span>Our Commitment</h3>
<p>
We are committed to:</p>
<ul>
  <li>Providing <b> legitimate and structured work opportunities </b></li>
  <li>Maintaining a  <b> secure and fair working environment</b></li>
  <li>Ensuring <b> clarity and transparency </b> in how tasks and earnings are handled</li>
  <li>Continuously improving the platform to meet the needs of modern freelancers</li>
</ul>
<h3>Our Vision</h3>
<p>
We believe that remote work should be accessible to anyone, anywhere. Solara aims to empower individuals by giving
them the tools and opportunities to earn, grow, and participate in the global digital economy.</p>
<p>
At Solara, we are building more than just a platform — we are creating a reliable gateway to remote work
opportunities.</p>



        </div>

        </div>
 

      <Footer/>
        

    </section>
   )
}

export default About;